export const BASE_S3_IMAGE_URL: string = 'https://s3.eu-central-1.amazonaws.com/totems3';
